import { render } from "./arquivo_xml.vue?vue&type=template&id=15761d36"
import script from "./arquivo_xml.vue?vue&type=script&lang=js"
export * from "./arquivo_xml.vue?vue&type=script&lang=js"

import "./arquivo_xml.vue?vue&type=style&index=0&id=15761d36&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__